module.exports = __webpack_public_path__ + "img/DE01913.3119ae4d.png";